import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const bcsTokenSelector = (state: RootState) => state.bcsToken;

export const bcsTokenDataSelector = createSelector(
  bcsTokenSelector,
  data => data.data?.access_token
);

export const bcsTokenFetchingSelector = createSelector(bcsTokenSelector, bcs => bcs.isFetching);

export const bcsTokenErrorSelector = createSelector(bcsTokenSelector, bcs => bcs.error);
